import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
var ImpressionsCacheInMemory = /*#__PURE__*/function () {
  function ImpressionsCacheInMemory() {
    _classCallCheck(this, ImpressionsCacheInMemory);

    this.queue = [];
  }
  /**
   * Get collected data
   */


  _createClass(ImpressionsCacheInMemory, [{
    key: "state",
    value: function state() {
      return this.queue;
    }
    /**
     * Store objects in sequential order
     */

  }, {
    key: "track",
    value: function track(data) {
      var _this$queue;

      (_this$queue = this.queue).push.apply(_this$queue, _toConsumableArray(data));

      return this;
    }
    /**
     * Recycle the collector queue
     */

  }, {
    key: "clear",
    value: function clear() {
      this.queue.length = 0;
      return this;
    }
    /**
     * Hook JSON.stringify to expose the state of the counters
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.queue;
    }
    /**
     * Check if the is data changed from the defaults
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.queue.length === 0;
    }
  }]);

  return ImpressionsCacheInMemory;
}();

export default ImpressionsCacheInMemory;